import { render, staticRenderFns } from "./LocationsSimpleTable.vue?vue&type=template&id=b7a063f4&scoped=true&"
import script from "./LocationsSimpleTable.vue?vue&type=script&lang=ts&"
export * from "./LocationsSimpleTable.vue?vue&type=script&lang=ts&"
import style0 from "./LocationsSimpleTable.vue?vue&type=style&index=0&id=b7a063f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a063f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VSimpleTable,VTextField,VTooltip})
